export default {
    api_url: process.env.API_URL,
    api_url_hubops: process.env.API_URL_HUBOPS,
    api_url_tms: process.env.API_URL_TMS,
    api_url_stagetms: process.env.API_URL_STAGETMS,
    xbmasterapi_url: process.env.XBMASTERAPI_URL,
    allocateRuleapi_url: process.env.ALLOCATERULEAPI_URL,
    shipmentupdates_url: process.env.SHIPMENTUPDATES_URL,
    lastmile_url: process.env.LASTMILE_URL,
    usermanagement_url :process.env.USERMANAGEMENT_URL,
    lastmile_url_Without_Expose :process.env.lastmile_url_Without_Expose,
    iptracking_url:process.env.IPTRACKING_URL,
    userauthentication_url:process.env.API_URL_USERAUTHENTICATION,
    api_url_kavach_auth:process.env.API_URL_KAVACH_AUTH,
    kavach_client_id:'hubops-ui',
    isKavachLogin:true,
    cloudfronturl:process.env.Cloud_Front_URL,
    CRMRedirectionalUrl:process.env.CRMRedirectionalUrl


    
    // api_url: 'https://stageusermanagementapi.xbees.in/api/',
    // api_url_hubops: 'https://huboperation-apistage.xbees.in/api/',
    // api_url_tms: 'http://stagetmsapi.xbees.in/',
    // api_url_stagetms: 'http://stagetmsapi.xbees.in/',
    // xbmasterapi_url: 'http://stagexbmasterapi.xbees.in:3600/expose/',
    // allocateRuleapi_url: 'https://huboperation-apistage.xbees.in/api/',
    // shipmentupdates_url: 'http://api.staging.shipmentupdates.xbees.in/',
    // lastmile_url: 'http://lastmileallocationpod-apistage.xbees.in/expose/',
    // usermanagement_url: 'http://stageautoallocation-app.xbees.in/api/',
    // lastmile_url_Without_Expose: 'http://lastmileallocationpod-apistage.xbees.in/',
    // iptracking_url:'http://stageiptracking.xbees.in/api/',
    // userauthentication_url:'https://stageusermanagementapi.xbees.in/api/',
    // api_url_kavach_auth:'https://stage-auth.xbees.in',
    // kavach_client_id:'hubops-ui',
    // isKavachLogin:true ,
    // cloudfronturl:'https://d39ohhrtdl20fq.cloudfront.net',
    // CRMRedirectionalUrl:'https://stagecltcrm-frontend.xbees.in/#/'
}



// WEBPACK FOOTER //
// ./src/constants.js